// src/components/Toast/index.tsx
import React from "react";
import { ToastContainer, toast } from "react-toastify";

// src/components/Toast/index.scss
var css = `/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: #e74c3c;
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);
  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);
  --toastify-toast-width: 320px;
  --toastify-toast-background: #fff;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;
  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(
    to right,
    #4cd964,
    #5ac8fa,
    #007aff,
    #34aadc,
    #5856d6,
    #ff2d55
  );
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  padding: 4px;
  width: var(--toastify-toast-width);
  box-sizing: border-box;
  color: #fff;
}
.Toastify__toast-container--top-left {
  top: 1em;
  left: 1em;
}
.Toastify__toast-container--top-center {
  top: 1em;
  left: 50%;
  transform: translateX(-50%);
}
.Toastify__toast-container--top-right {
  top: 1em;
  right: 1em;
}
.Toastify__toast-container--bottom-left {
  bottom: 1em;
  left: 1em;
}
.Toastify__toast-container--bottom-center {
  bottom: 1em;
  left: 50%;
  transform: translateX(-50%);
}
.Toastify__toast-container--bottom-right {
  bottom: 1em;
  right: 1em;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast-container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
    top: 0;
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
    bottom: 0;
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: initial;
  }
}
.Toastify__toast {
  position: relative;
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  max-height: var(--toastify-toast-max-height);
  overflow: hidden;
  font-family: var(--toastify-font-family);
  cursor: default;
  direction: ltr;
  /* webkit only issue #791 */
  z-index: 0;
}
.Toastify__toast--rtl {
  direction: rtl;
}
.Toastify__toast--close-on-click {
  cursor: pointer;
}
.Toastify__toast-body {
  margin: auto 0;
  flex: 1 1 auto;
  padding: 6px;
  display: flex;
  align-items: center;
}
.Toastify__toast-body > div:last-child {
  word-break: break-word;
  flex: 1;
}
.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 20px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.7s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast {
    margin-bottom: 0;
    border-radius: 0;
  }
}
.Toastify__close-button {
  color: #fff;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  align-self: flex-start;
}
.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}
.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}
.Toastify__close-button:hover, .Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}
.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  z-index: var(--toastify-z-index);
  opacity: 0.7;
  transform-origin: left;
}
.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}
.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}
.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
}

@keyframes Toastify__bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes Toastify__bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}
.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}
.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}
.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}
.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}
.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}
.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
@keyframes Toastify__flipOut {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}
.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
}
@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
}
@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}
@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}
.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}
.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}
.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}
.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
}
.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
}
.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
}
.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
}

:root {
  --toastify-color-success: #fff;
}

.Toastify__close-button--light {
  color: #fff;
  opacity: 0.5;
}

#wr_custom_notify {
  background-color: #199ce3;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
#wr_custom_notify a {
  text-decoration: underline !important;
  color: #fff !important;
}

.Toastify__close-button > svg {
  width: 19px !important;
  height: 19px !important;
}

.text-green > .Toastify__close-button {
  color: #1ab394 !important;
}

.text-noti-warn > .Toastify__close-button {
  color: #946300 !important;
}

.text-noti-error > .Toastify__close-button {
  color: #c8192e !important;
}

.Toastify__toast-container .Toastify__toast-theme--light::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-repeat: repeat;
  background-size: cover;
  z-index: 0;
}

.Toastify .Toastify__toast-icon {
  width: auto;
  height: 48px;
  margin-inline-end: 16px;
}
.Toastify .Toastify__close-button {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  align-self: flex-start !important;
  opacity: 1 !important;
}
.Toastify .Toastify__toast-body {
  padding: 0;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css));

// src/components/Toast/index.tsx
import { Translation } from "react-i18next";

// src/assets/images/error.png
var error_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA5CAYAAACMGIOFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAuWSURBVHgB5VpdUhvHFu6ekXJxIGX5LSlEECsAr+CKh2sbvwArAK0AWIHFCoAVACsAHm4wzgNiBYYVIAeT5M2iLNkkGs3c72t1T1rDjGYGRN1K5VTBjHqmf87pc77z0yPEP4CkeEQ6/v77iuu6pRfX1+em7e3U1K4bBE0Pcy98/FiPvr/w++9NMWJyxIjpeGpq9WRycoX3slBY94Wo2s8h1RIZjJvYKRa3fi6X34gR08iZ9H3/XEi5/q5cPvWDADM4s/bzIAhKvH5pt7ejffFMUgBGSKOigngAHZfLVScIpv1e78yo2bfFYvNPz+N9qSDlrCCjNknZXLi6qseNhXcbjuM0Hd8Pos/J+Mvr631xD3rQTjpSrmGnbqCW4a7MN5stXCo9z6u9+PhxvifE2UGpVDLPsfqzuLFkEMwFUtJ2l9pfvgy8cwIVRr9n4v9BmPz9ydTUwdvJyXW7/d3k5JzISUYQP/3ww5LdTjDCHJfvAFjinpQZXZOQD2pWhzrMSinFi6urZTFiohCl71ewy3O+5808BvoqIoNkRiQsYlhfANDacaVSCd8vlwfehxZsJ/U9npxcPUmYNw+l2iTVxy0UdmF/K1RPTmw/9113Y1h/2OSF43lhH9hWaJ//7av106S+C9fXey8jvtQmmMWuAqwUSmXy9W+/HWKhm4D3I+j2XvT5QrPZHNYfDr+Bfv+mNtjttMGilFtBr7cpchL7vi2Xt30pb8DAWtr72dCVLkFKSnwJO7pogwPvowxEiUgLBN4ieDAY4AK/nZg4hcvYSLOxqM8kg+i7C9e1h7Gm4YuPxChJ2VdEPRT6RewsifS777Oi709A7SiTp5VKyQgVeLBku6dHJdjpXtbJsIunIiOlgVpWuqOuXCzjx+MhqGZ2xGZs7DEkGgRhAMCAIOpDk9YWbbsT1o2NjZW8IJhBSHYpEoh2hN3boV1B1POulNMvUgCIO4iopkKbhAqqsRGmzQzrA3trahtcA8MzAMFEkKIZYR1rvSC4wM+6yEJ0FQyybRuMSkm/8ylPQJ1HXWm7FAj+9ux2W4O4JgKZior6661Hx0mNeOxIh4MBXZ/2fF/FlpDcCiT3AW2zyCrml1utFoVCtxEdh3kkELGCW4KOyi8Z20bfo0r+8fVrg2Od9NOuOdn3rYder/eh6LqzSN/mMF9NzadzVrSt0R0hXZt7eXV1mIvJOKY5EFKq0m2nc6gmwo6qYF3KBnKtZ1DD1Tv9dNSDwODALxRU+BfnY+PGUir73XdVzqmymIgQTTaUlKVIa/FVSKRlZ/F5SMWYQVDttNsztKFer3fBQMI8V+Gb4zxFHFoNHKfBtldXVzVr/opTKBxQI8DQrhmLQhQPpBBdpesy1Tmlz+NfFiQLGaRa+f4NVHdjfGLiUoPEoW3PGPsQUdM+dqLFq7rXxLlub29bAJod1V+PpYBtBKgdMgkVCaDXF4gVl6nvkGTmHUV2sE+1whiMQFgZmMXObkGFVs07VDH+IXZtmXvzjAImQ0iYZ01/mgLWUMu7k9SIaAlFMUmJ+wzZkDJRqnQjeVIa5VIwOBPbV9fX87QbLHD1S6eznqk/gnAyzz5fO51l7uiT8fHV+5gO8KKOWPuZzegA8FigsrQQAx5ZSKku1BVCaxBAaGNsn4CdBv2iVh9dIYhet7tJAYV90AZBLxqkFjmJYR7GmWPmwvsAeSiEvp3aMUsqM/C+5Ut1PvhepWh6HOMnVY4K/0ffZvvB3PMBtc2c0QqFoaFZCINhXKpcSFYgGlDzXq8hdHXutt0+j76Hnb4EIFWE64YBQpyPjSMyhqzmIOh21+kn2Za0ayqss6WHwm+r0+k0qS66KFVnO6WN91pmERTArefN8TcFQDSlitiOmPbhd7vzolBYNSGgeWZU9JtC4Tmqe0TRI6OitKd2u73zrydPqgoAC4WKLQAVACCRh7rXXmfADrWTREEMtuQCeHpSKuCJvvhNsbhuJ6iA/BLqOiqccx1nSzX6/pZ5TiFgzGnuGIEFNnpERlXsqhkkIlOQfDY2MRGmXwCOKgN+oq5ikJFSP1pSxKI1E/ms4CiNVOG3bqLbrXcr1HMIYwXgsK87lpjxc4FkHtcdCGkNk++Y50TrnlWCZAlF9IP0lnlPt6v6LF2YmSfguGhnkC4dpxR9btahhBwEh0RirvcPz6sHnretk4hVrCEo0Nkqu0C17a3O3KFif2XsmGRALPq3TyZRQVO/0Xfgqp8H5vlfFCImBPIJDv9GvdtnnAXlpsX4JRqmMcYHoKQceI6Awh4X0ZUal1oBVd5m5ISNY9MRkTZXSRLq8wa7XQt/F4tvGJoxU2DaZK58TqnC1nYZXPC3UVEsepoFZttVwJb3wOiesTkicFAo1ES/ANYwqsrClpq7n2k04kCKYMR0i7sLbaGJnWY6JggNHbUa0wa7bUGVlcogK+lX7BwnrNwpqZbLFyp4hlobGyQDtFG0C9rou/HxmqDtWgv+2m4vk3lomTGfAWQeQ8W+i0Af62pG7bLz+bMdJa3y39CdNLvBe4RuG3kLu6p/t/se6nVudpRMvtIpFlM32bfn+ayuw5Dyja5bZ8KuQGhI/ztMRvNB2mye6IPGblIwDWjPCCC47vFgCMi4y50immKHt6i6BLBQde9xsJO2xpBJpkqwiwuFgFLWX/7yy71OkAbyQQCLKQ6rdsdZZAoFu2zg2kAqta8TbR418Nk5gWZYQXkYUUD2CdtdJvtlRQXvrHJDPZfzqCer4agL7Zp8UDB7//z5eVTCtroOLBChHwRTYp/x8fEtMHz4n19/zVVT1cd/q0pzoCHQmDrnD8M6+iD8bUC6y5Dk8zwMcpf+RJQU5oPQCAT5m6qAnIGYluFyhP777M/dJIN5cloSzWwMQQvvIaRQhUfyzYBRN62iFTRVuKN2ysaQj+ULqjKFoRalXYKxKZ5twCOqit5DVJdF6ddWYDOS43STD+J2iQk3mWDcaWuDrs9UVMDeDz4q5pkpSFGbjCqjRFKNO3LPQq8jkVv+Qhb0Hp2WNFPKIeuqmsQiKbVFqnu0H8uLiIsZ6m3RLNgWB/tKdQFYZiyjEfDTi0yGEdJd5kXfO8EA7Qsh1zkXpEqOOrHVC2Bk0kQ0su12uyWoFuuuPOo+M2oFZg7jJuJXIAgDZ1WBWQf2FFL0PQDPprElBgzKRvEeY11mSLjOMfXr6IBBF5UH1hmlOzupqm64MjRCDrg9zP+Yuqjo14bqYgiZkqREcKFCNpF+7EeBUyC0UbtaYGzYTtAZkdEXx+1ynE3u60S3kYFBqSIZZhEpBObWyaDDYjGuUkdSQ/uAQWQUNZOmmcrdwLoQ9ThIuj0eD0BLciHysFKgKs1bpQaWMewj82GU61SrXG6EcwDBk8ob4ZFGyjnpgyjPwh/r6E6dWybUh1KzEJOI8qRZ+S84ebtUqKQXzTkTSCGzVin6wbSAA27niLtnJ/NJX6HoUk0jbpxUP8nOyl34/gXqN8vRWiiLSGnn/qrohB1keYUJLzN9AsXJjz8OPQ1jsABGmwONKIfk/aYn1U+q+iWCaoDAItxHLW9KRCKDzEW5A3bsqr/R2cxTROaRPoCoBn8Z+I5zHrjuZhpKpxIBaBiopJ1VqNqrdX5p26QGsHtFNRz3537Mm0qp6kq4TpIUF4lyfupETH+snxfmhjsLDfmU1E+hZsJHFFRlr9vdEY9J3F3axmPCNkEv65clw+heWQii/O2CDgCip8XqnLNYVCfQKETtZUnZjKCSvt0TCUWrrHSvLARRPou7Z2QkapNYaAPt+5JIGiHaZtL3BfxqOQ41WbQCKj/oa+Z7p1pMr1DLWY8L/ZTU4SqiO4OAniXJ53F2xiQX7uLOPHRhdpXwPvSgL5ejDHJXkTWs8KNBEbNgEjOYO5/DuG416FfcY4HkoZ9/jvQbdNRm+F3qB9ZZWNy1n9G/qeqB51Wi/ZTTR00p+lH+35JYlsh7/jgK+h+rp2aEl7pN2wAAAABJRU5ErkJggg==";

// src/assets/images/warn.png
var warn_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALYSURBVHgB7ZnvbdpAGMYf/+FzvUHTDdggZoLCBDGhkRq1hDBB6QSmoVErtRAyAekE0AkSJigjkK81+PqcDVJxDQT5bEeqf1JwfMan97m71897Bigo+L/RoJDrBloCqHol1NtfMUMG6FCE+xZHDL7Lf+2ShxtkhDIBpoeOPAoRjLzdewMbGaBEgBx9Ho6D4HXUg44FWsgAJQKM37CZTEeahk7zOyZsmshccB1YSBklAhj4Bzn67/u4ledCw0d5NHVcImUSC7g6hROMvo67dZucBSmIwlppz0JiAZoIk5VL5sfmBfzkp1UycYwUSb6E1iMvcLNK5sAPOCsncha8BaZIESVGxmV0qWtwOQszfYmaMHAvg1/4qLSH6RqakiS+GNDABB5kLvgGRqvm27SDlyiZgV4DVXY0iraLJSq77tNLmL/7hgckwIQCuFwsTQ6FhqphYrrw4PK0qhkY77zPDw6JBlGJgDXMgcdzFnG9Oh7l4vRF6MpxUPAJI7eREKUCojA3htuuUaQtRfZOwxpqF3wYdJlP87hrqQp4CtLF933HNMPyJPYacsYo4VVcO/OoE3gJ8GlVX8WSu4DzmI2PLE/oK4ERNge76yll+wFVSDfXpCmujHDf93OfgSjcGI25dCyho9Ye7DfCVAV8ccLaKI6Fjhdx7Qx+xsORIfASTyBVAUsDv7Zd2+Ze3hJ17iPGvobu9Rmm+5xaaQ4wKPdzg+6r4/XqfPj3HyKPQj5h7qJ9BPVTuC21fB+jffsJJTOw9DHhhmbGIMtMvjmT0JLBcYe24cQ9h1tPY8N9J1cOnGh/YsEPg33KNxxhcbg1mZW9F6KzDilClgdDBu9wW1mJPr/dM5RLPu5xIHF9rcn0KdTmemblWpPF3yH3XfSfkZE1+/+u+yQ8OyM7lEJA3hQC8qYQkDeFgLwpBOSNcgEs1MrIEJUCwhdPWrYClP5OvP5lkq9EEr+0LSjIiD/0i9lvHbUopQAAAABJRU5ErkJggg==";

// src/assets/images/success.png
var success_default = "data:image/png;base64,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";

// src/components/Toast/index.tsx
var Toast = () => {
  return /* @__PURE__ */ React.createElement(ToastContainer, { hideProgressBar: true });
};
var notify = async (msg, type = "success") => {
  switch (type) {
    case "error":
      toast.error(
        /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Translation, null, (t) => /* @__PURE__ */ React.createElement("span", null, t("txt_error"))), msg && typeof msg === "string" && /* @__PURE__ */ React.createElement("p", { className: "fw-normal m-0" }, msg)),
        {
          className: "bg-red-10 fw-bold text-red-100 ps-4 bg-noti-bg-error text-noti-error",
          icon: () => /* @__PURE__ */ React.createElement("img", { alt: "error", src: error_default })
        }
      );
      break;
    case "warn":
      toast.warn(
        /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Translation, null, (t) => /* @__PURE__ */ React.createElement("span", null, t("txt_warning"))), msg && typeof msg === "string" && /* @__PURE__ */ React.createElement("p", { className: "fw-normal m-0" }, msg)),
        {
          className: "bg-yellow-10 fw-bold text-yellow-200 ps-4 bg-noti-bg-warn text-noti-warn",
          icon: () => /* @__PURE__ */ React.createElement("img", { alt: "warn", src: warn_default })
        }
      );
      break;
    case "success":
      toast.success(
        /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Translation, null, (t) => /* @__PURE__ */ React.createElement("span", null, t("txt_successful"))), msg && typeof msg === "string" && /* @__PURE__ */ React.createElement("p", { className: "fw-normal m-0" }, msg)),
        {
          className: "bg-primary-10 bg-noti-bg-success text-green fw-bold ps-4",
          icon: () => /* @__PURE__ */ React.createElement("img", { alt: "success", src: success_default })
        }
      );
      break;
    case "promise":
      return await toast.promise(
        msg,
        {
          pending: {
            render() {
              return /* @__PURE__ */ React.createElement("span", { className: "p-15 pe-2" }, "Progressing...");
            },
            icon: () => /* @__PURE__ */ React.createElement("img", { alt: "success", src: success_default })
          },
          success: {
            render() {
              return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Translation, null, (t) => /* @__PURE__ */ React.createElement("span", null, t("txt_successful"))), msg && typeof msg === "string" && /* @__PURE__ */ React.createElement("p", { className: "fw-normal m-0" }, msg));
            },
            className: "bg-primary-10 text-green bg-noti-bg-success  fw-bold ps-4",
            icon: () => /* @__PURE__ */ React.createElement("img", { alt: "success", src: success_default })
          },
          error: {
            render() {
              return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Translation, null, (t) => /* @__PURE__ */ React.createElement("span", null, t("txt_error"))), msg && typeof msg === "string" && /* @__PURE__ */ React.createElement("p", { className: "fw-normal m-0" }, msg));
            },
            className: "bg-red-10 fw-bold bg-noti-bg-error text-noti-error text-red-100 ps-4",
            icon: () => /* @__PURE__ */ React.createElement("img", { alt: "error", src: error_default })
          }
        },
        {
          className: "bg-dark"
        }
      );
    default:
      toast.info(msg, {
        className: "bg-info"
      });
      break;
  }
};
var notifyHTML = (text) => {
  return toast.success(/* @__PURE__ */ React.createElement("div", { dangerouslySetInnerHTML: { __html: text } }), {
    className: "bg-noti-bg-success text-green fw-bold px-2 py-1",
    icon: () => /* @__PURE__ */ React.createElement("img", { alt: "success", src: "/assets/images/success.png" })
  });
};

export {
  Toast,
  notify,
  notifyHTML
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
